import React from "react";

export const Logo = ({ className = "" }) => (
  <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
    <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-full bg-green-600 text-white">
      <span className="font-display font-bold">T</span>
    </span>
    <span className="flex flex-col leading-none">
      <span className="font-display font-bold tracking-tight text-slate-900 text-lg">
        TERAFI<span className="text-green-600">QUIRO</span>
      </span>
      <span className="mt-0.5 text-[9px] font-semibold tracking-[0.28em] uppercase text-green-600">
        Wellness Center
      </span>
    </span>
  </div>
);
